<div
  class="round-badge color-hinvalid"
  [class]="'round-badge-size-' + size + ' round-badge-color-' + color"
>
  <span class="round-badge-label">
    <ng-content />
  </span>
</div>
